<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title:!user_permissions.includes('delete-macro-categories')? $t('permission.permission_denied', { permission: 'delete-macro-categories' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="macros_category_remove" variant="primary" :class="!user_permissions.includes('delete-macro-categories') ? 'cursor-not-allowed' : ''"
                        :disabled="!user_permissions.includes('delete-macro-categories')">{{ $t('simple.delete') }}</b-button>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Macro Category Remove Modal mounted');
        },

        destroyed() {
            // Component Destroyed
            console.log('Macro Category Remove Modal destroyed.');
        },

        data: function() {
             return  {

                macros_category_api: '/api/v1/settings/macros/categories/',

             }
        },

        methods: {

            macros_category_remove: async function(){

                // Loading start
                this.$wait.start('delete');

                await axios.delete(this.macros_category_api + this.id)
                    .then((response) => {

                        // Show success
                        Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                        // Loading stop
                        this.$wait.end('delete');

                        // Close modal
                        this.$close(true);


                    }
                )
                    .catch((error) => {
                        // Show error
                      if (error.response && error.response.status === 403) {
                        Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'delete-macro-categories'}));
                      } else {
                        Vue.toasted.error(this.$t('simple.error_info'));
                      }
                        // Loading stop
                        this.$wait.end('delete');

                        // Close modal
                        this.$close(true);

                    }
                );

            },
        },
      computed: {
        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'

        }),
      }
    }
</script>